<app-schedule-list *ngIf="!ScheduleEditList" [ListScheduleInputProperty]="isListorUpdateView"
  (ListOutputSchedule)="EmitChildComponent($event)"></app-schedule-list>



<app-schedule-edit *ngIf="ScheduleEditList" [EditScheduleInputProperty]="isListorUpdateView"
  (EditOutputSchedule)="EmitChildComponent($event)"></app-schedule-edit>
